<template>
    <div class="modal fade" id="repayment_modal" tabindex="-1" aria-labelledby="repayment_modal" aria-hidden="true">
        <div class="modal-dialog modal-fullscreen-sm-down">
            <div class=" modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-3 fw-bold">{{ title }}</h1>
                    <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
                </div>
                <div class="modal-body">
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <div class="text-center">
                        <h3 class="text-primary my-3">
                            <font-awesome-icon icon="fas fa-circle-info" size="4x" />
                        </h3>

                        <h5>Do you confirm you want to pay again? Please don't proceed if you have already successfully paid.</h5>
                        <div class="my-5">
                            <div class="d-grid gap-2 mb-2">
                                <button @click="redeemVoucher()" type="button" class="btn btn-primary btn-lg">
                                    <span v-if="!btn_loading">Yes</span>
                                    <span v-if="btn_loading">
                                        <font-awesome-icon icon="fas fa-circle-notch" spin />
                                    </span>
                                </button>
                            </div>

                            <div class="d-grid gap-2 mb-2">
                                <button data-bs-dismiss="modal" type="button" class="btn btn-secondary btn-lg">
                                    <span v-if="!btn_loading">Cancel</span>
                                    <span v-if="btn_loading">
                                        <font-awesome-icon icon="fas fa-circle-notch" spin />
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ViewRecordQrModal from "../_modal/ViewRecordQr.vue";

export default {
    components: {
        ViewRecordQrModal,
    },
    props: {
        title: String,
    },
    data() {
        return {
            btn_loading: false,
        };
    },
    mounted() {

    },
    methods: {
        redeemVoucher() {
            this.btn_loading = true;
            this.$parent.redeemVoucher()
        }
    },
};
</script>
